import { render, staticRenderFns } from "./LimitNbhds.vue?vue&type=template&id=0ecf070c&scoped=true&lang=pug&"
import script from "./LimitNbhds.vue?vue&type=script&lang=js&"
export * from "./LimitNbhds.vue?vue&type=script&lang=js&"
import style0 from "./LimitNbhds.vue?vue&type=style&index=0&id=0ecf070c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf070c",
  null
  
)

export default component.exports